export default __webpack_public_path__ + "static/media/SIFA_NL_EPILOGFIN03.1205ab85.mp3";